function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1369.83,249,1567.12,51.75a30.31,30.31,0,0,0,0-42.87h0a30.31,30.31,0,0,0-42.87,0L1327,206.17a9.83,9.83,0,0,1-13.92,0L1115.75,8.88a30.31,30.31,0,0,0-42.87,0h0a30.31,30.31,0,0,0,0,42.87L1270.17,249a9.83,9.83,0,0,1,0,13.92L1072.88,460.25a30.31,30.31,0,0,0,0,42.87h0a30.31,30.31,0,0,0,42.87,0L1313,305.83a9.83,9.83,0,0,1,13.92,0l197.29,197.29a30.31,30.31,0,0,0,42.87,0h0a30.31,30.31,0,0,0,0-42.87L1369.83,263A9.83,9.83,0,0,1,1369.83,249Z",
  transform: "translate(-1064)"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.45f7df53.svg";
export { ForwardRef as ReactComponent };